import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { ALPHA_NUMERIC_WITH_UNDERSCORE_DASH } from '../../utils/regex.js';
export class IdvDocuments extends BaseMessage {
    documentType;
    documentTypeId;
    document;
    documentId;
    ocisEvidenceTypeCode;
    ocisEvidencePurposeCode;
}
__decorate([
    Field.string({
        description: 'documentType',
        required: true,
        minLength: 1,
    }),
    __metadata("design:type", String)
], IdvDocuments.prototype, "documentType", void 0);
__decorate([
    Field.string({
        description: 'documentTypeId',
        required: true,
        pattern: ALPHA_NUMERIC_WITH_UNDERSCORE_DASH,
        minLength: 1,
    }),
    __metadata("design:type", String)
], IdvDocuments.prototype, "documentTypeId", void 0);
__decorate([
    Field.string({
        description: 'document',
        required: true,
        minLength: 1,
    }),
    __metadata("design:type", String)
], IdvDocuments.prototype, "document", void 0);
__decorate([
    Field.string({
        description: 'documentId',
        required: true,
        pattern: ALPHA_NUMERIC_WITH_UNDERSCORE_DASH,
        minLength: 1,
    }),
    __metadata("design:type", String)
], IdvDocuments.prototype, "documentId", void 0);
__decorate([
    Field.string({
        description: 'ocisEvidenceTypeCode',
        required: true,
        minLength: 1,
    }),
    __metadata("design:type", String)
], IdvDocuments.prototype, "ocisEvidenceTypeCode", void 0);
__decorate([
    Field.string({
        description: 'ocisEvidencePurposeCode',
        required: true,
        minLength: 1,
    }),
    __metadata("design:type", String)
], IdvDocuments.prototype, "ocisEvidencePurposeCode", void 0);
//# sourceMappingURL=IdvDocuments.js.map